<template>
<nav class="NavigationList f f-row">
    <ol class="f f-col">
        <li v-for="(item, index) in menuItems" v-bind:key="index">
            <a :href="'#' + item.goTo" :class=item.class v-smooth-scroll>{{ item.text }}</a>
        </li>
    </ol>
    <div class="SocialMediaIconsWrapper f f-col">
        <SocialMediaIcons :icons=socialMedia :white=true :iconsWidth="'15px'" />
    </div>
</nav>
</template>

<script>
import SocialMediaIcons from "@/components/SocialMediaIcons";

export default {
    name: "NavigationList",
    components: {
        SocialMediaIcons
    },
    props: {
        menuItems: Array,
        socialMedia: Object
    }
};
</script>

<style lang="scss" scoped>
nav.NavigationList {
    align-items: flex-end;
}
.SocialMediaIconsWrapper {
    padding-right: 15px;
    margin-top: 10px;

    a {
        &:hover {
            text-decoration: none;
        }
    }
}

.pratkowieckalech .NavigationList {
    margin-bottom: -20px;
}
</style>
